import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicationsComponent } from './pages/publications/publications.component';
import { SponsorsComponent } from './pages/sponsors/sponsors.component';
import { DisplayGeneComponent } from './pages/display-gene/display-gene.component';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';
import { AboutComponent } from './pages/about/about.component';
import { DownloadsComponent } from './pages/downloads/downloads.component';
import { ContactComponent } from './pages/contact/contact.component';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { DatasetSelectionComponent } from './pages/dataset-selection/dataset-selection.component';
import { Gwas15Component } from './pages/gwas15/gwas15.component';
import { ToolSelectionComponent } from './pages/tool-selection/tool-selection.component';
import { GeneLevelMultiComponent } from './pages/gene-level-multi/gene-level-multi.component';
import { SnpLevelMultiComponent } from './pages/snp-level-multi/snp-level-multi.component';
import { GseaAnalysisComponent } from './pages/gsea-analysis/gsea-analysis.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomepageComponent, title: 'GEM•HD | Home' },
  { path: 'gwas-15', component: Gwas15Component, title: 'GEM•HD | GWAS 1-5 Study' },
  // `data.family` is bound straight onto each component's `family` @Input by
  // bindToComponentInputs (below), so one set of pages serves every study family.
  { path: 'gwas-16', component: ToolSelectionComponent, data: { family: 'gwas16' }, title: 'GEM•HD | GWAS 1-6 Analysis Tools' },
  { path: 'gwas-16/datasets', component: DatasetSelectionComponent, data: { family: 'gwas16' }, title: 'GEM•HD | GWAS 1-6 Datasets' },
  { path: 'gwas-16/gene-multi', component: GeneLevelMultiComponent, title: 'GEM•HD | Gene-Level Multi-Endpoint Viewer' },
  { path: 'gwas-16/snp-multi', component: SnpLevelMultiComponent, data: { family: 'gwas16' }, title: 'GEM•HD | SNP-Level Multi-Endpoint Viewer' },
  { path: 'gwas-16/gsea', component: GseaAnalysisComponent, title: 'GEM•HD | Pathway Analysis' },
  {
    path: 'gwas-16/display/:id',
    component: DisplayGeneComponent,
    data: { family: 'gwas16' },
    title: 'GEM•HD | Dataset Explorer',
  },

  // Enroll-HD WGS+ (v3). Brand-neutral titles: isGemHdPage() deliberately excludes these routes,
  // so the GeM-HD wordmark and red header do not apply to this study.
  { path: 'enroll-hd', component: ToolSelectionComponent, data: { family: 'v3' }, title: 'Enroll-HD WGS+ | Analysis Tools' },
  { path: 'enroll-hd/datasets', component: DatasetSelectionComponent, data: { family: 'v3' }, title: 'Enroll-HD WGS+ | Datasets' },
  { path: 'enroll-hd/snp-multi', component: SnpLevelMultiComponent, data: { family: 'v3' }, title: 'Enroll-HD WGS+ | SNP-Level Multi-Endpoint Viewer' },
  {
    path: 'enroll-hd/display/:id',
    component: DisplayGeneComponent,
    data: { family: 'v3' },
    title: 'Enroll-HD WGS+ | Dataset Explorer',
  },
  {
    path: 'publications',
    component: PublicationsComponent,
    title: 'GEM•HD | Publications',
  },
  {
    path: 'sponsors',
    component: SponsorsComponent,
    title: 'GEM•HD | Sponsors',
  },
  { path: 'about', component: AboutComponent, title: 'GEM•HD | About' },
  {
    path: 'contact',
    component: ContactComponent,
    title: 'GEM•HD | Contact',
  },
  {
    path: 'downloads',
    component: DownloadsComponent,
    title: 'GEM•HD | Downloads',
  },
  { path: 'help', component: ComingSoonComponent, title: 'GEM•HD | Help' },
  // Legacy route for backward compatibility
  {
    path: 'display/:id',
    redirectTo: 'gwas-16/display/:id',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
